import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { GuidaImageInputButton, useGuidaUIStates } from '@inter-ikea-guida/framework';
import { SkapaText } from '@inter-ikea-guida/skapa';
import bags from '../../assets/bags.webp';
import folding from '../../assets/folding.webp';
import hanging from '../../assets/hanging.webp';
import jewellery from '../../assets/jewellery.webp';
import shoes from '../../assets/shoes.webp';
import trousers from '../../assets/trousers.webp';
import underwear from '../../assets/underwear.webp';
import { useIsKiosk } from '../../contexts/environment';
import { useAppDispatch } from '../../store';
import { selectPill } from '../../store/app';
import { getFormState, getCMSState } from '../../store/app/selectors';
import { getTranslation } from '../../store/i18n/selectors';
import { PILL } from '../../utils';
import { getSingleSurveyPayload } from '../../utils/insights/getSurveyPayload';
import { sendInsightsEvent } from '../../utils/insights/sendInsights';
import { StyledGuideHeading, StyledGuideSubHeading, StyledLegend, StyledStorageNeeds } from './styles';
const images = { folding, hanging, shoes, bags, jewellery, trousers, underwear };
export const NeedsGuide = ({ scrollToGuide }) => {
    const { isSidebarMode } = useGuidaUIStates();
    const dispatch = useAppDispatch();
    const translate = useSelector(getTranslation);
    const formState = useSelector(getFormState);
    const cmsState = useSelector(getCMSState);
    const filterTypes = [PILL];
    const isKiosk = useIsKiosk();
    const headingRef = useRef(null);
    // Scroll to this guide heading if specified
    useEffect(() => {
        if (headingRef.current && scrollToGuide) {
            headingRef.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
    }, [scrollToGuide]);
    const selectOption = useCallback((id, value, icf) => {
        dispatch(selectPill({
            id,
            value,
            tags: icf || []
        }));
    }, [dispatch]);
    const onClick = (id, value, icf) => {
        sendInsightsEvent('whatIsMe', 'select_survey_option', getSingleSurveyPayload(id, value, formState.storage_type));
        selectOption(id, value, icf);
    };
    // Get all pill items from the CMS data
    const cmsPillItems = cmsState.form.filter(item => filterTypes.includes(item.type));
    const subheading = translate('guid01FwStorageNeedsSubheading')
        .replace('{{numberSelected}}', formState.storage_type.length.toString())
        .replace('{{numberMaximum}}', '3');
    return (_jsxs("div", { "data-testid": 'needs-guide', children: [_jsx(StyledGuideHeading, { ref: headingRef, "$alignCenter": !isSidebarMode, children: _jsx(SkapaText, { tagName: 'h2', textStyle: isSidebarMode ? 'Heading.L' : 'Heading.M', children: translate('guid01FwGuidingStep2BtnLabel') }) }), _jsx(StyledGuideSubHeading, { children: _jsx(SkapaText, { tagName: 'h3', textStyle: 'Body.L', children: subheading }) }), cmsPillItems.map((item, index) => (_jsxs(StyledStorageNeeds, { "$columns": 2, children: [_jsx(StyledLegend, { children: translate('guid01FwGuidingStep2BtnLabel') }), item.options.map(option => {
                        return (_jsx(GuidaImageInputButton, { inputType: 'checkbox', isKiosk: isKiosk, dataTestId: `${item.type}-${option.value}`, selected: formState[item.id].includes(option.value), label: translate(option.label), value: option.value, onClick: () => onClick(item.id, option.value, option.icf), imageUrl: images[option.value], aspectRatio: '3/2', disabled: formState.storage_type.length === 3 &&
                                !formState.storage_type.includes(option.value) }, option.value));
                    })] }, index)))] }));
};
//# sourceMappingURL=NeedsGuide.js.map